




























import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import { Message } from 'element-ui';
import AuthModule from '@/store/auth';

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Login extends Vue {
  username = '';

  password = '';

  isLoading = false;

  get userInfo() {
    return {
      username: this.username,
      password: this.password,
    };
  }

  async onLogin() {
    this.isLoading = true;

    try {
      await AuthModule.login(this.userInfo);

      await this.$router.push({ path: '/' });
    } catch (e) {
      Message.error('Invalid login!');
    }

    this.isLoading = false;
  }
}
